module.exports = __webpack_public_path__ + "static/template-team-member-4-d2fb2659fdf1c88448006eb977936b06.jpg";